import React from 'react';
import { Loading } from '../../services/Loading';
import {
  Stack,
  Pivot,
  PivotItem,
  Text,
  PrimaryButton,
  Dialog,
  DialogType,
  DialogFooter,
  DefaultButton,
  Callout,
  DirectionalHint,
  FocusTrapZone,
  Calendar,
  DayOfWeek,
  mergeStyleSets,
} from 'office-ui-fabric-react';
import NoDataTile from '../common/NoDataTile';
import { useParams, useHistory } from 'react-router-dom';
import { ICardHolder, ICustomers } from '../../vm';
import { getAllCustomers } from '../../services/customers/CustomerService';
import CustomerCard from './CustomerCard';
import Icon from '@mdi/react';
import { mdiNumeric, mdiDomain } from '@mdi/js';
import {
  API_URL,
  childrenGap,
  childrenGap8,
  DayPickerStrings,
} from '../common/Constants';
import { getToken } from '../../services/UtilService';
import moment from 'moment';
import ReportApprovalStatus from './customer-reports/ReportApprovalStatus';
import CustomerReportMain from './customer-reports/CustomerReportMain';

export interface CustomerDetailsProps {}

let calendarButtonElement: HTMLElement;

// const DayPickerStrings = {
//   months: [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ],
//   shortMonths: [
//     "Jan",
//     "Feb",
//     "Mar",
//     "Apr",
//     "May",
//     "Jun",
//     "Jul",
//     "Aug",
//     "Sep",
//     "Oct",
//     "Nov",
//     "Dec",
//   ],
//   days: [
//     "Sunday",
//     "Monday",
//     "Tuesday",
//     "Wednesday",
//     "Thursday",
//     "Friday",
//     "Saturday",
//   ],
//   shortDays: ["S", "M", "T", "W", "T", "F", "S"],
//   goToToday: "Go to today",
//   weekNumberFormatString: "Week number {0}",
//   prevMonthAriaLabel: "Previous month",
//   nextMonthAriaLabel: "Next month",
//   prevYearAriaLabel: "Previous year",
//   nextYearAriaLabel: "Next year",
//   prevYearRangeAriaLabel: "Previous year range",
//   nextYearRangeAriaLabel: "Next year range",
//   closeButtonAriaLabel: "Close",
//   monthPickerHeaderAriaLabel: "{0}, select to change the year",
//   yearPickerHeaderAriaLabel: "{0}, select to change the month",
// };

const CustomerDetails: React.FC<CustomerDetailsProps> = () => {
  //state
  const [state, setState] = React.useState({
    isLoading: false,
    isCustomerFound: true,
    customer: {
      name: '',
      regSapNo: '',
      email: '',
    },
    selectedKey: 'information',
    isModalOpen: false,
    date: new Date(),
    showCallender: false,
  } as {
    isLoading: boolean;
    isCustomerFound: boolean;
    customer: ICustomers;
    selectedKey: string;
    isModalOpen: boolean;
    date: Date;
    showCallender: boolean;
  });

  //hooks
  const params: any = useParams();
  const history = useHistory();

  React.useEffect(() => {
    const asyncFunc = async () => {
      let hash = window.location.hash;
      if (hash) {
        hash = hash.substr(1);
        setState({ ...state, selectedKey: hash });
      }
      await getACustomer();
    };
    asyncFunc();
    console.log('params', params);
  }, []);

  const getACustomer = async () => {
    setState({ ...state, isLoading: true });
    let result = await getAllCustomers({ customerId: params.customerId });
    if (result && result.success && result.data.length > 0) {
      setState({
        ...state,
        customer: result.data[0],
        isLoading: false,
        isCustomerFound: true,
      });
    } else {
      setState({ ...state, isLoading: false, isCustomerFound: false });
      //toast
    }
  };

  const _getTabId = (itemKey: string): string => {
    return `${itemKey}`;
  };

  const handleCallToRouter = (value: any) => {
    setState({
      ...state,
      selectedKey: value.props.itemKey,
    });
    history.push(window.location.pathname + '#' + value.props.itemKey);
  };

  const downloadReport = async () => {
    setState({ ...state, isLoading: true });
    const customerName = state.customer.name;
    console.log('state.date', state.date);
    const result = await fetch(
      `${API_URL}mor-reports?customerId=${state.customer._id}&date=${moment(
        state.date
      ).format('yyyy-MM-DD')}`,
      {
        method: 'GET',
        credentials: 'include', // Enable credentials for CORS
        headers: {
          at: getToken(),
        },
      }
    );
    const pptx = await result.blob();
    const pptxFile = new Blob([pptx], {
      type:
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    });
    const pptxFileUrl = window.URL.createObjectURL(pptxFile);
    var a: any = document.createElement('a');
    // document.body.appendChild(a);
    // a.style = 'display:none';
    a.href = pptxFileUrl;
    a.download = `${customerName}.pptx`;
    a.click();

    setState({ ...state, isModalOpen: false, isLoading: false });
  };

  const closeCallender = (ev?: any) => {
    setState({
      ...state,
      showCallender: false,
    });
  };

  const maxDate: Date = moment(Date.now()).endOf('month').toDate();

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      {state.isCustomerFound ? (
        <>
          <Stack tokens={childrenGap8}>
            <Stack.Item>
              <Text className='page-title' style={{ lineHeight: 0 }}>
                {state.customer.name}
              </Text>
            </Stack.Item>
            <Stack.Item>
              <Text className='customer-sap-code'>
                {state.customer.regSapNo}
              </Text>
            </Stack.Item>
            {/* <Stack.Item>
              <PrimaryButton
                text="Download Report"
                onClick={() => setState({ ...state, isModalOpen: true })}
              />
            </Stack.Item> */}
            {/* <Stack.Item>
            <Stack horizontalAlign="space-between" horizontal>
              <Stack.Item>
                <Stack horizontal>
                  <Stack.Item>
                    <Icon path={mdiDomain} size={1.1} className="mr-8" />
                  </Stack.Item>
                  <Stack.Item>
                    <Text variant="large">{state.customer.name}</Text>
                  </Stack.Item>
                </Stack>
                <Stack horizontal>
                  <Stack.Item>
                    <Icon path={mdiNumeric} size={1.1} className="mr-8" />
                  </Stack.Item>
                  <Stack.Item>
                    <Text variant="large">{state.customer.regSapNo}</Text>
                  </Stack.Item>
                </Stack>
              </Stack.Item>
              <Stack.Item>
                <PrimaryButton
                  text="Download Report"
                  onClick={() => setState({ ...state, isModalOpen: true })}
                />
              </Stack.Item>
            </Stack>
          </Stack.Item> */}
            {/* <br /> */}
            {/* <Stack.Item>
              <CustomerCard customerId={params.customerId} />
            </Stack.Item> */}
            {/* <Stack.Item>
            <Pivot
              onClick={handleCallToRouter}
              defaultSelectedKey="overview"
              selectedKey={state.selectedKey}
              getTabId={_getTabId}
            >
              <PivotItem itemKey="overview" headerText="Overview"></PivotItem>
              <PivotItem
                itemKey="access-log"
                headerText="Access Log"
              ></PivotItem>
            </Pivot>
          </Stack.Item> */}
          </Stack>
          <Stack className='pt-8'>
            <Pivot
              onLinkClick={handleCallToRouter}
              defaultSelectedKey='information'
              selectedKey={state.selectedKey}
              getTabId={_getTabId}>
              <PivotItem itemKey='information' headerText='Information'>
                <CustomerCard customerId={params.customerId} />
              </PivotItem>
              <PivotItem itemKey='report' headerText='Report'>
                {/* <ReportApprovalStatus
                  customerId={params.customerId}
                  customer={state.customer}
                /> */}
                <CustomerReportMain
                  customerId={params.customerId}
                  customer={state.customer}
                />
              </PivotItem>
            </Pivot>
          </Stack>
        </>
      ) : (
        <NoDataTile title='No Customer Found' />
      )}
      {state.isModalOpen && (
        <React.Fragment>
          <Dialog
            hidden={!state.isModalOpen}
            onDismiss={() =>
              setState({ ...state, isModalOpen: false, date: new Date() })
            }
            modalProps={{
              isBlocking: true,
              styles: { main: { maxWidth: 450 } },
            }}
            dialogContentProps={{
              type: DialogType.normal,
              title: 'Select a month to download report',
              // subText: `Do you want to Reject the ${subText}`,
            }}>
            <Stack>
              <div
                ref={(calendarBtn) => (calendarButtonElement = calendarBtn!)}>
                <DefaultButton
                  text={
                    !state.date
                      ? 'Select a month'
                      : moment(state.date).format('MMM-YYYY')
                  }
                  style={{ width: 268 }}
                  className='month-picker-btn'
                  onClick={() => setState({ ...state, showCallender: true })}
                />
              </div>
              {state.showCallender && (
                <Callout
                  isBeakVisible={false}
                  // className="ms-DatePicker-callout"
                  gapSpace={0}
                  doNotLayer={false}
                  target={calendarButtonElement}
                  directionalHint={DirectionalHint.bottomLeftEdge}
                  onDismiss={() => closeCallender()}
                  setInitialFocus>
                  <FocusTrapZone
                    firstFocusableSelector='ms-DatePicker-day--today'
                    isClickableOutsideFocusTrap>
                    <Calendar
                      // eslint-disable-next-line react/jsx-no-bind
                      onSelectDate={(date: Date | null | undefined) => {
                        // console.log('state Date', state.date);
                        console.log('Date', date);
                        setState({
                          ...state,
                          date: date as any,
                          showCallender: false,
                        });
                      }}
                      onDismiss={() => closeCallender()}
                      isMonthPickerVisible={true}
                      value={state.date}
                      firstDayOfWeek={DayOfWeek.Sunday}
                      strings={DayPickerStrings}
                      isDayPickerVisible={false}
                      highlightCurrentMonth={false}
                      highlightSelectedMonth={true}
                      showMonthPickerAsOverlay={false}
                      showGoToToday={false}
                      maxDate={maxDate}
                    />
                  </FocusTrapZone>
                </Callout>
              )}
            </Stack>
            <DialogFooter className='d-flex'>
              <DefaultButton
                text='Cancel'
                className='borderless-btn'
                onClick={() =>
                  setState({ ...state, isModalOpen: false, date: new Date() })
                }
              />
              <PrimaryButton text='Download Report' onClick={downloadReport} />
            </DialogFooter>
          </Dialog>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CustomerDetails;
